import { render, staticRenderFns } from "./WeddingConfirm.vue?vue&type=template&id=c30a3662&scoped=true"
import script from "./WeddingConfirm.vue?vue&type=script&lang=js"
export * from "./WeddingConfirm.vue?vue&type=script&lang=js"
import style0 from "./WeddingConfirm.vue?vue&type=style&index=0&id=c30a3662&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c30a3662",
  null
  
)

export default component.exports